import {CSSProperties, FC} from 'react';


export interface IIconVideoAvitoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconVideoAvito: FC<IIconVideoAvitoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <g stroke="#000" opacity=".5">
                <circle cx="18" cy="18" r="13.35" strokeWidth="1.3" />
                <path fillRule="evenodd" strokeWidth=".225" d="M14.477 11.117c-.426.111-.754.427-.905.871l-.063.184-.007 5.875c-.006 3.94.001 5.936.02 6.06.058.375.212.663.464.87.214.174.41.24.726.242.462.004.295.091 3.041-1.59.905-.555 2.957-1.81 4.56-2.79 3.237-1.98 3.226-1.972 3.417-2.36.054-.109.111-.274.129-.368.086-.467-.178-1-.648-1.302-.095-.062-1.84-1.06-3.878-2.22a29428.728 29428.728 0 0 1-5.423-3.084 6.344 6.344 0 0 0-.677-.344c-.215-.073-.566-.093-.756-.044Zm.381 1.217c.148.062 9.678 5.493 9.734 5.547.05.049.05.051-.017.11-.07.061-9.518 5.852-9.703 5.947a.735.735 0 0 1-.117.053c-.009 0-.015-2.631-.015-5.847 0-3.216.006-5.848.014-5.848s.055.017.104.038Z" clipRule="evenodd" />
            </g>
        </svg>
    );
};
